import React from 'react';

const NotFound = () => {
  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#ffffff',
        textAlign: 'center'
      }}
    >
      <h1 style={{ fontSize: '4rem', marginBottom: '10px' }}>404</h1>
      <p style={{ fontSize: '1.2rem' }}>Page Not Found</p>
    </div>
  );
};

export default NotFound;
